import { gql } from '__generated__'

export const GetOverlappingRosterCandidates = gql(/* GraphQL */ `
    query GetOverlappingRosterCandidates(
        $rosterId: ID!
        $otherRosterIds: [ID!]!
        $page: Int
        $limit: Int
    ) {
        overlappingRosterCandidates(
            rosterId: $rosterId
            otherRosterIds: $otherRosterIds
            page: $page
            limit: $limit
        ) {
            pageInfo {
                itemTotal
            }
            data {
                rosterCandidate {
                    id
                    candidate {
                        user {
                            firstName
                            nickname
                            lastName
                        }
                    }
                    candidateId
                    candidateProcessStatus {
                        processStatus {
                            status
                            statusLabel
                            processStatusSummaryGroup {
                                summaryGroup
                                label
                            }
                        }
                    }
                    candidateColors {
                        rosterColor {
                            id
                            value
                            order
                            hexCode
                        }
                    }
                }
                referenceRosterCandidates {
                    rosterId
                    candidateProcessStatus {
                        processStatus {
                            status
                            statusLabel
                            processStatusSummaryGroup {
                                summaryGroup
                                label
                            }
                        }
                    }
                }
            }
        }
    }
`)

export const GetMissingRosterCandidates = gql(/* GraphQL */ `
    query GetMissingRosterCandidates(
        $rosterId: ID!
        $otherRosterIds: [ID!]!
        $page: Int
        $limit: Int
    ) {
        missingRosterCandidates(
            rosterId: $rosterId
            otherRosterIds: $otherRosterIds
            page: $page
            limit: $limit
        ) {
            pageInfo {
                itemTotal
            }
            data {
                candidate {
                    id
                    user {
                        firstName
                        nickname
                        lastName
                    }
                }
                referenceRosterCandidates {
                    rosterId
                    candidateProcessStatus {
                        processStatus {
                            status
                            statusLabel
                            processStatusSummaryGroup {
                                summaryGroup
                                label
                            }
                        }
                    }
                }
            }
        }
    }
`)

export const AddToRoster = gql(/* GraphQL */ `
    mutation AddToRoster(
        $candidateIds: [ID!]!
        $rosterId: ID!
        $processStatusId: ID
        $internalNote: String
        $externalNote: String
    ) {
        addCandidatesToRoster(
            rosterId: $rosterId
            candidateIds: $candidateIds
            processStatusId: $processStatusId
            internalNote: $internalNote
            externalNote: $externalNote
        ) {
            message
            success
            data {
                id
                candidateId
            }
        }
    }
`)

export const AddCandidateToMultipleRosters = gql(/* GraphQL */ `
    mutation AddCandidateToMultipleRosters(
        $candidateId: ID!
        $rosterIds: [ID!]!
        $processStatusId: ID
        $internalNote: String
        $externalNote: String
    ) {
        addCandidateToMultipleRosters(
            candidateId: $candidateId
            rosterIds: $rosterIds
            processStatusId: $processStatusId
            internalNote: $internalNote
            externalNote: $externalNote
        ) {
            success
            message
        }
    }
`)
